"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDifferenceDurationInMinutes = exports.dateIsBeforeOrAfterCompareDate = exports.getDateStringWithoutTime = exports.getTimeString = exports.getDateString = exports.editDate = exports.getDifferenceInMinutes = exports.getDifferenceInDays = exports.isDateWithinChosenDaysFromNow = exports.isDateChosenTimeAway = exports.howOftenDoesDurationFitBetweenDates = exports.dateDifferenceMinutes = exports.areDatesWithinTimeRange = exports.isInFuture = exports.isSameDay = exports.addHours = exports.getDateNow = void 0;
var moment_1 = __importDefault(require("moment"));
var moment_range_1 = require("moment-range");
/** Use to to get date now in order to mock it in tests */
var getDateNow = function (mockDateNow) { return (mockDateNow ? mockDateNow : Date.now()); };
exports.getDateNow = getDateNow;
/** Cannot use * as Moment due to typescript issue when calling moment functions,
 * use default import and as any in extendMoment
 *
 * https://github.com/rotaready/moment-range/issues/263
 */
var moment = moment_range_1.extendMoment(moment_1.default);
var addHours = function (date, hours) {
    var asDate = new Date(date);
    var result = asDate.setHours(asDate.getHours() + hours);
    return new Date(result);
};
exports.addHours = addHours;
/**
 * Check if date0 and date1 are on the same day
 */
var isSameDay = function (date0, date1) {
    return date0.getDate() === date1.getDate() ||
        date0.getMonth() === date1.getMonth() ||
        date0.getFullYear() === date1.getFullYear();
};
exports.isSameDay = isSameDay;
var isInFuture = function (date, customFutureDate) {
    return Math.round(date - (customFutureDate ? customFutureDate : getDateNow())) / (1000 * 60 * 60) >= 0;
};
exports.isInFuture = isInFuture;
var minutesOfDay = function (date) {
    var d = new Date(date);
    return d.getMinutes() + d.getHours() * 60;
};
/** checks if date is within user input timerange,
 *
 * Accepts ISO date which ignores anything else than minutes */
var areDatesWithinTimeRange = function (startDate, endDate, rangeStartTime, rangeEndTime) {
    return minutesOfDay(startDate) >= minutesOfDay(rangeStartTime) && minutesOfDay(endDate) <= minutesOfDay(rangeEndTime);
};
exports.areDatesWithinTimeRange = areDatesWithinTimeRange;
var dateDifferenceMinutes = function (start, end) {
    if (start instanceof Date && end instanceof Date) {
        return Math.round((end.getTime() - start.getTime()) / 60000);
    }
    return Math.round((Date.parse(end) - Date.parse(start)) / 60000);
};
exports.dateDifferenceMinutes = dateDifferenceMinutes;
var howOftenDoesDurationFitBetweenDates = function (startDate, endDate, 
/** duration always 30 min */
duration) { return Math.floor(dateDifferenceMinutes(startDate, endDate) / duration); };
exports.howOftenDoesDurationFitBetweenDates = howOftenDoesDurationFitBetweenDates;
var isDateChosenTimeAway = function (date, daysFromNow) {
    var chosenTimeFromNow = moment(getDateNow()).add(daysFromNow, 'days');
    return moment(date).isAfter(chosenTimeFromNow, 'day');
};
exports.isDateChosenTimeAway = isDateChosenTimeAway;
var isDateWithinChosenDaysFromNow = function (date, daysFromNow) {
    var today = moment(getDateNow());
    var withinChosenTime = moment(getDateNow()).add(daysFromNow, 'days');
    return moment(date).isBetween(today, withinChosenTime, 'day', '[]');
};
exports.isDateWithinChosenDaysFromNow = isDateWithinChosenDaysFromNow;
var getDifferenceInDays = function (date, compareToDate) {
    var momentDate = moment(date);
    var comparisonDate = compareToDate ? moment(compareToDate) : moment(getDateNow());
    var differenceBetween = momentDate.diff(comparisonDate, 'days');
    return differenceBetween;
};
exports.getDifferenceInDays = getDifferenceInDays;
var getDifferenceInMinutes = function (date, compareToDate) {
    var momentDate = moment(date);
    var comparisonDate = moment(compareToDate);
    var differenceBetween = momentDate.diff(comparisonDate, 'minutes');
    return differenceBetween;
};
exports.getDifferenceInMinutes = getDifferenceInMinutes;
var editDate = function (date, editByAmount, unitToChange) {
    return moment(date).add(editByAmount, unitToChange);
};
exports.editDate = editDate;
var getDateString = function (date) { return moment(date).format('D.M.YYYY'); };
exports.getDateString = getDateString;
var getTimeString = function (date) { return moment(date).utcOffset(180).format('HH:mm'); };
exports.getTimeString = getTimeString;
var getDateStringWithoutTime = function (dateString) { return dateString.split('T')[0]; };
exports.getDateStringWithoutTime = getDateStringWithoutTime;
/** Used to check eg. if a showing is at least a day before or after reservation */
var dateIsBeforeOrAfterCompareDate = function (date, compareToDate, beforeOrAfter) {
    var dateWithoutTime = getDateStringWithoutTime(date);
    var compareToDateWithoutTime = getDateStringWithoutTime(compareToDate);
    var isBeforeOrLater = beforeOrAfter === 'before'
        ? moment_1.default(dateWithoutTime).isBefore(compareToDateWithoutTime)
        : moment_1.default(dateWithoutTime).isAfter(compareToDateWithoutTime);
    return isBeforeOrLater;
};
exports.dateIsBeforeOrAfterCompareDate = dateIsBeforeOrAfterCompareDate;
var getDifferenceDurationInMinutes = function (date0, date1) {
    var differenceDuration = moment.duration(moment(date0).diff(date1));
    var differenceDurationInMinutes = differenceDuration.asMinutes();
    return differenceDurationInMinutes;
};
exports.getDifferenceDurationInMinutes = getDifferenceDurationInMinutes;
//# sourceMappingURL=dates.js.map